export const file_upload = {
  label: 'Загрузить файл',
  button: 'Загрузить',
  format: 'Формат файла',
  weight: 'Максимальный размер файла не должен превышать 10Мб.',
  drag: 'Нажмите или перетащите файл сюда, чтобы загрузить.',
  max_5000:
    'Файл должен быть без заголовков столбцов, без пустых строк, содержать номера в международном формате, не более 5000 строк.',
  file_example: 'Вы можете использовать',
  download_example: 'Вы можете скачать',
  template: 'шаблон.',
  invalid_format: 'Неверный формат файла',
  row_1000: 'Файл не должен содержать более 1000 задач без учета заголовка.',
  weight_mb: 'Максимальный размер файла не должен превышать {weight}Мб.',
  file_processing: 'Файл загружается',
  file_fail: 'Ошибка файла'
};
